module.exports = __webpack_public_path__ + "static/media/icon-edit.907408c7.svg";